import React from "react";
import Header from "../../Common/Header";
import Editor from "@monaco-editor/react";
import "./useAnswerQuestion";
import useAnswerQuestion from "./useAnswerQuestion";
export default (props) => {
  const {
    language,
    editorValue,
    compiledCode,
    languageDropdown,
    onSubmitCode,
    onLanguageChange,
    handleEditorChange,
    handleEditorDidMount,
    handleEditorWillMount,
    handleEditorValidation,
    questionDetails,
    onCompileCode,
  } = useAnswerQuestion();
  return (
    <div className="hiring-process-dashboard">
      <Header />

      <div className="bg-grey-3 py-2">
        <div className="container d-flex justify-content-between align-items-center">
          <h2 className="py-3">Answer Question </h2>
        </div>
        <div className="container">
          <div className="job-detail mt-5 bg-grey-5 px-3">
            <div className="top bg-grey-2 py-3 px-3 mx-n3">
              <h3 className="font-weight-medium">
                <strong>Question:</strong> {questionDetails?.question_coding}
              </h3>
            </div>
            <div className="my-3">
              <p>
                <strong>Description</strong>: {questionDetails?.description}
              </p>
            </div>
            <div className="row">
              <div className="col-lg-9">
                <div className="form-group my-4">
                  <div className="d-flex justify-content-end align-items-center mb-4">
                    <span className="select mr-4">
                      <select
                        className="form-control bg-transparent"
                        onChange={(e) => onLanguageChange(e)}
                        name={"language"}
                      >
                        <option
                          disabled={true}
                          value=""
                          selected={language === null}
                        >
                          Select language
                        </option>
                        {languageDropdown &&
                          Array.isArray(languageDropdown) &&
                          languageDropdown.map((item) => (
                            <option
                              key={item?.id}
                              selected={language === item}
                              value={item.id}
                            >
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </span>
                  </div>
                </div>
                <div className="form-group my-4">
                  <Editor
                    height="400px"
                    onChange={handleEditorChange}
                    onMount={handleEditorDidMount}
                    beforeMount={handleEditorWillMount}
                    onValidate={handleEditorValidation}
                    language={language && language.split(" ")[0].toLowerCase()}
                    defaultLanguage="javascript"
                    defaultValue="Start writing code here..."
                    theme="vs-dark"
                  />
                  {/* <div className="text-grey-4">Code Output: {status?.description} , {output && atob(output)}</div> */}
                </div>
                <div className="form-group my-4 text-right">
                  <button className="btn btn-primary" onClick={onCompileCode}>
                    Run Code
                  </button>
                  <button className="btn btn-primary" onClick={onSubmitCode}>
                    Submit Code
                  </button>
                </div>
              </div>

              <p>{compiledCode?.stderr && atob(compiledCode?.stderr)}</p>

              <p>{compiledCode?.stdout && atob(compiledCode?.stdout)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
